import React from 'react';
import classNames from 'classnames';
import { exposedTranslationButtonProps } from '../../utils/props';
import { STYLES } from './constants';
import DefaultTranslationButton from './DefaultTranslationButton';
import LeanDefaultTranslationButton from './LeanDefaultTranslationButton';
import LeanToggledTranslationButton from './LeanToggledTranslationButton';
import LeanWithDisclaimerTranslationButton from './LeanWithDisclaimerTranslationButton';
import LeanTranslationButton from './LeanTranslationButton';
import TranslationButtonWithEducation from './TranslationButtonWithEducation';

const MachineTranslationButton = ({ style = STYLES.DEFAULT, ...props }) => {

    const renderTranslationButton = () => {
        switch (style) {
            case STYLES.DEFAULT:
                return <DefaultTranslationButton {...props}/>;
            case STYLES.LEAN_DEFAULT:
                return <LeanDefaultTranslationButton {...props}/>;
            case STYLES.LEAN_TOGGLED:
                return <LeanToggledTranslationButton {...props}/>;
            case STYLES.LEAN_WITH_DISCLAIMER:
                return <LeanWithDisclaimerTranslationButton {...props}/>;
            case STYLES.LEAN:
                return <LeanTranslationButton {...props}/>;
            case STYLES.WITH_EDUCATION:
                return <TranslationButtonWithEducation {...props}/>;
            default:
                return <DefaultTranslationButton {...props}/>;
        }
    };

    const wrapperClass = classNames(
        'machine-translation-package',
        'machine_translation-package',
        'machine-translation-button'
    );

    return (
        <div className={wrapperClass}>
            {renderTranslationButton()}
        </div>
    );
};

MachineTranslationButton.propTypes = exposedTranslationButtonProps;

Object.assign(MachineTranslationButton, {
    STYLES
});

export default MachineTranslationButton;
